import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/city', component: List, name: 'city.index'},
  {path: '/city/store', component: Form, name: 'city.store'},
  {path: '/city/:id', component: Form, name: 'city.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/city/routes.js